<template>
  <div class="container mx-auto w-full md:px-10 mb-8 px-6">
    <div
      class="flex flex-col justify-center md:flex-row md:flex-row-reverse bg-white"
    >
      <div class="w-full md:w-1/2 px-6 flex justify-center">
        <ui-image
          :src="section.imageDesktop"
          class="app-banner-image-desktop hidden md:block"
          contain
        />
        <ui-image
          :src="section.imageMobile"
          class="app-banner-image-mobile md:hidden"
          contain
        />
      </div>
      <div
        class="w-full md:w-1/2 flex flex-col px-6 md:px-15 py-10 md:py-20 rounded-lg text-center sm:text-left"
      >
        <ui-title type="h1" html-tag="h2">{{ section.title }}</ui-title>
        <p>{{ section.description }}</p>
        <div class="flex flex-col sm:flex-wrap sm:flex-row py-5">
          <a class="apple badge self-center" :href="links.ios" target="_blank">
            <img
              v-lazy="
                `https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/${appleBadge}.svg`
              "
              alt="Download on the App Store"
            />
          </a>
          <a
            class="google badge self-center"
            :class="{ 'google-full-width': lang === 'fr' || lang === 'tr' }"
            :href="links.android"
            target="_blank"
          >
            <img
              ref="google"
              v-lazy="
                availableGoogleLocales.includes(lang)
                  ? require(`@/assets/images/google-play-badges/${lang}_get.png`)
                  : require(`@/assets/images/google-play-badges/en_get.png`)
              "
              alt="Get it on Google Play"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/prop-name-casing */
import VueTypes from 'vue-types'
import { mapGetters } from 'vuex'
import { APPSTORE_URL } from './constants'
import { availableLocales } from '@/assets/images/google-play-badges/available-locales'
import { UiImage, UiTitle } from '~/components/atoms'

export default {
  components: {
    UiImage,
    UiTitle,
  },
  props: {
    section: VueTypes.object.def({}),
  },
  data() {
    return {
      useGoogleFallback: false,
    }
  },
  computed: {
    ...mapGetters('context', ['locale', 'isGlobalMarketplace', 'language']),
    lang() {
      if (this.isGlobalMarketplace) {
        return this.language.displayLanguage.toLowerCase()
      }
      return this.locale.split('-')[0]
    },
    links() {
      return {
        ios: APPSTORE_URL.ios,
        android: APPSTORE_URL.android,
      }
    },
    appleBadge() {
      if (this.isGlobalMarketplace) {
        return this.language.language
      }
      return this.locale
    },
    availableGoogleLocales() {
      return availableLocales
    },
  },
  mounted() {
    this.$refs.google.onerror = this.shouldUseGoogleFallback
  },
  methods: {
    shouldUseGoogleFallback() {
      this.useGoogleFallback = true
    },
  },
}
</script>
<style>
.apple {
  padding: 15px 15px 15px 0;
  min-width: 180px;
}

.google {
  width: 205px;
  margin-left: -15px;
}

.google-full-width {
  width: 218px;
}

.badge {
  height: 90px;
}

img {
  height: 100%;
  width: auto;
}

.app-banner-image-mobile,
.app-banner-image-desktop {
  align-self: center;
  max-width: 350px;
  max-height: 340px;
}
</style>
